module.exports = __webpack_public_path__ + "static/media/ekoenergia.2d9d5cbc.svg";